/** @jsx jsx */
import React from 'react'
import { Flex, jsx, Box } from 'theme-ui'
import Heading from '../shared/Typography/Heading/Heading'
import Body from '../shared/Typography/Body/Body'
import { ProductPrice } from './ProductCard'
import CustomStarRating from '../shared/StarRating/StarRating'
import Tag from '../shared/Tag/Tag'

const ProductHeading = props => {
  return (
    <Box
      sx={{
        width: '100%',
        ...props.styles,
      }}
    >
      <Flex
        sx={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Heading
          as="producttitle"
          sx={{
            maxWidth: '75%',
          }}
        >
          {props.title}
        </Heading>

        <Body
          sx={{
            textTransform: 'uppercase',
            color: '#3B3A38',
          }}
        >
          {props.loaded && (
            <ProductPrice
              price={props.currentValue && props.currentPrice}
              compareAtPrice={props.currentValue && props.currentCompareAtPrice}
              includesSavingsPercentage={false}
              currency={props.convertedCurrency}
              textStyles={{
                fontSize: ['14px', '16px', '16px'],
                lineHeight: ['20px', '24px', '24px'],
                fontWeight: 'semiBold',
              }}
            />
          )}
        </Body>
      </Flex>
      {props.currentValue && props.currentCompareAtPrice && (
        <Box>
          <Body
            sx={{
              fontSize: '12px',
              lineHeight: '16px',
              color: 'secondary',
              letterSpacing: '1px',
              my: 10,
              mb: '10px',
              fontWeight: 'semiBold',
            }}
          >
            {Math.round(
              (1 - props.currentPrice / props.currentCompareAtPrice) * 100
            )}
            % OFF
          </Body>
        </Box>
      )}
      <Box sx={{ mt: '10px', mb: ['5px', null, '10px'] }}>
        {props.primaryTag &&
          props.primaryTag.map((tag, k) => {
            return (
              <Tag
                style={{ marginRight: '5px' }}
                key={k}
                text={tag.tagText}
                bodyVariant={tag.tagStyle}
              />
            )
          })}
      </Box>
      {/* {props.avgScore && (
        <Flex sx={{ my: 10, cursor: 'pointer' }} onClick={props.executeScroll}>
          <CustomStarRating
            name="productCardRating"
            rating={props.avgScore}
            reviewCount={props.numberOfBusinessReviews}
            starDimension="15px"
          />
        </Flex>
      )} */}
    </Box>
  )
}

export default ProductHeading
